export enum Language {
    FR = "fr",
    EN = "en",
    'EN-US' = "en"
}